<template>


<div   class="calculation_node " :ref="'node'+node.id" :id="'node'+node.id" :style="offsets" :class="box_shadow">
<div class="calculation_node_left_notch calculation_node_notch" :class="leftnotch_active" :id="'left_notch'+node.id" v-if="node.key!=='sources'"></div>
<div class="calculation_node_right_notch calculation_node_notch" :class="rightnotch_active" :id="'right_notch'+node.id" v-if="node.key!=='outputs'"></div>
<!-- header-->
<div class="calculation_node_header" :class="bgcolor">
<div class="calculation_node_header_text" :id="'handle'+node.id">{{node.title}}</div>
<div class="calculation_node_header_icon " @click="showContent">
<span class="material-symbols-outlined  text-white md-20">visibility</span>
</div>
</div>
<!-- header-->


</div>


</template>

<script>
export default {

  name: 'CalculationNode',
  props:["node"],
  data () {
    return {
    	input1val:null,
    	input2val:null,
    	active:false,
    	show_content:false,  
    	conditionoperators:[
    	{name:">",id:"lowerthan",text:"Küçüktür"},
    	{name:"=",id:"equalto",text:"Eşittir"},
    	{name:"<",id:"higherthan",text:"Büyüktür"},
    	],
    	condition_action_operators:[
    	{name:"Puan Ekle",id:"add_points"},
    	{name:"Puan Çıkar",id:"remove_points"},
    	{name:"Sabit Puan",id:"set_points"},
    	]
    }
  },
  watch:{
  	node()
  	{
  		if(this.node.input1 && this.node.input1.type=="value")
  		{
  			this.input1val = this.node.input1.value
  		}

  		if(this.node.input2 && this.node.input2.type=="value")
  		{
  			this.input2val = this.node.input2.value
  		}
  	},
  },
  computed:{
  	box_shadow()
  	{
  		
  		if(this.$store.state.calculations.selectednode)
  		{
  			if(this.$store.state.calculations.selectednode.id == this.node.id)
	  		{
	  			if(this.node.key=="sources")
		  		{
		  			return "calculation_node_variable_selected"
		  		}
		  		if(this.node.key=="calculations")
		  		{
		  			return "calculation_node_calculation_selected"
		  		}

		  		if(this.node.key=="conditions")
		  		{
		  			return "calculation_node_condition_selected"
		  		}
		  		if(this.node.key=="outputs")
		  		{
		  			return "calculation_node_equation_selected"
		  		}
	  		}
  		}
  		
  	},
  	input1()
  	{
  		
  		if(this.node.input1)
  		{
  			if(this.node.input1.type=="connection")
  			{
  				let connections = this.$store.state.calculations.connections
	  			let nodes = this.$store.state.calculations.nodes
	  			let connected = connections.find((item)=>{return item.id == this.node.input1.connection_id})
	  			if(connected)
	  			{
	  				let from = nodes.find((item)=>{return item.id == connected.from})
	  				return from
	  			}
	  			else
	  			{
	  				let node_ind = nodes.findIndex((item)=>{return item.id == this.node.id})
	  				nodes[node_ind].input1 = null
	  				this.$store.dispatch('calculations/setNodes',nodes)
	  				return null
	  			}
	  			
  			}
  			else
  			{
  				this.input1val = this.node.input1.value
  				return this.node.input1.value
  			}
  			
  		}
  		else
  		{
  			return null
  		}  		
  	},

  	input2()
  	{
  		if(this.node.input2)
  		{
  			if(this.node.input2.type=="connection")
  			{
  				let connections = this.$store.state.calculations.connections
	  			let nodes = this.$store.state.calculations.nodes
	  			let connected = connections.find((item)=>{return item.id == this.node.input2.connection_id})
	  			if(connected)
	  			{
	  				let from = nodes.find((item)=>{return item.id == connected.from})
	  				return from
	  			}
	  			else
	  			{
	  				let node_ind = nodes.findIndex((item)=>{return item.id == this.node.id})
	  				nodes[node_ind].input2 = null
	  				this.$store.dispatch('calculations/setNodes',nodes)
	  				return null
	  			}
  			}
  			else
  			{
  				this.input2val = this.node.input2.value
  				return this.node.input2.value
  			}
  			
  		}
  		else
  		{
  			return null
  		}  				
  	},
  	coordinates()
  	{
  		if(this.show_content)
  		{
  			return "left:"+this.node.top+"px;left:"+this.node.left+"px;z-index:100"
  		}
  		else
  		{
  			return "left:"+this.node.top+"px;left:"+this.node.left+"px;"
  		}
  		
  	},
  	offsets()
  	{
  		if(this.show_content)
  		{
  			return "left:"+this.node.offsetX+"px;top:"+this.node.offsetY+"px;z-index:100"
  		}
  		else
  		{
  			return "left:"+this.node.offsetX+"px;top:"+this.node.offsetY+"px"
  		}
  		
  	},
  	showclass()
  	{
  		if(this.show_content)
  		{
  			return "open"
  		}
  		else
  		{
  			return ""
  		}
  	},
  	bgcolor()
  	{
  		if(this.node.key=="sources")
  		{
  			return "calculation_node_variable"
  		}

  		if(this.node.key=="logicals")
  		{
  			return "logical_node_variable"
  		}
  		if(this.node.key=="calculations")
  		{
  			return "calculation_node_calculation"
  		}

  		if(this.node.key=="conditions")
  		{
  			return "calculation_node_condition"
  		}
  		if(this.node.key=="outputs")
  		{
  			return "calculation_node_equation"
  		}
  		if(this.node.key=="datalayer")
  		{
  			return "calculation_node_datalayer"
  		}
  	},
  	rightnotch_active()
  	{
  		if(this.$store.state.calculations.fromnode && this.$store.state.calculations.fromnode.id==this.node.id)
  		{
  			return "full"
  		}
  		else
  		{
  			let connections = this.$store.state.calculations.connections
  			for (let i = 0; i <connections.length; i++) {
  				if(connections[i].from == this.node.id)
  				{
  					return "full"
  				}
  			}
  			return ""
  		}
  	},
  	leftnotch_active()
  	{
  		if(this.$store.state.calculations.tonode && this.$store.state.calculations.tonode.id==this.node.id)
  		{
  			return "full"
  		}
  		else
  		{
  			let connections = this.$store.state.calculations.connections
  			for (let i = 0; i <connections.length; i++) {
  				if(connections[i].to == this.node.id)
  				{
  					return "full"
  				}
  			}
  			return ""
  		}
  	}

  },
  mounted()
  {

    





  },
  methods:{
  	swapInputs()
  	{
  		let nodes = this.$store.state.calculations.nodes

  		let node_ind = nodes.findIndex((item)=>{return item.id == this.node.id})

  		if(nodes[node_ind].input1 || nodes[node_ind].input2)
  		{
  			let input1 = this.sanitizeArray(nodes[node_ind].input1)
  			let input2 = this.sanitizeArray(nodes[node_ind].input2)
  			nodes[node_ind].input1 = input2
  			nodes[node_ind].input2 = input1
  			this.$store.dispatch('calculations/setNodes',nodes)
  		}

  	},
  	deleteConnection(input)
  	{
  		console.log(this.node[input])
  		//return false
  		let connections = this.$store.state.calculations.connections
  		//let connections = connections.find((item)=>{return item.id == this.node[input].connection_id})
  		connections = connections.filter((item)=>{return item.id !==this.node[input].connection_id})  		
  		this.$store.dispatch('calculations/setConnections',connections)  		
  		let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == this.node.id})
  		nodes[ind][input] = null
  		console.log(nodes)
  		setTimeout(()=>{
  			if(input=='input1')
  			{
  				this.input1val = null
  			}
  			if(input=='input2')
  			{
  				this.input2val = null
  			}
  			this.$store.dispatch('calculations/setNodes',nodes)
  			this.$store.state.calculations.fromnode = null
  		},10) 		

  	},
  	deleteValue(input)
  	{

  		let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == this.node.id})
  		nodes[ind][input] = null
  		setTimeout(()=>{
  			if(input=='input1')
  			{
  				this.input1val = null
  			}
  			if(input=='input2')
  			{
  				this.input2val = null
  			}
  			this.$store.dispatch('calculations/setNodes',nodes)
  		},10) 
  	},
  	nodeinputValueChanged(e,input)
  	{
  		let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == this.node.id})
  		if(this.node[input])
  		{
  			console.log("input val set")
  			nodes[ind][input].value = e.value
  			this.$store.dispatch('calculations/setNodes',nodes)
  		}
  		else
  		{
  			console.log("input val not set")
  			let val_item = {value:e.value,type:"value"}
  			nodes[ind][input] = val_item
  			this.$store.dispatch('calculations/setNodes',nodes)

  		}
  		console.log(e)
  	},
  	showContent()
  	{  		
  		console.log(this.node)
  		this.$store.dispatch('calculations/setSidebar',true) 
  		this.$store.dispatch('calculations/setSelectedNode',this.node)
  	},

   
   
    deleteNode()
    {
    	let nodes = this.$store.state.calculations.nodes
    	let connections = this.$store.state.calculations.connections
    	let node_ind = nodes.findIndex((item)=>{return item.id == this.node.id})

    	console.log("deleteNode")
    	console.log(this.node)


    	if(this.node.type=="variable")
    	{
    		let output_cons = connections.filter((item)=>{return item.from==this.node.id})
    		for(let output_conn of output_cons)
    		{
    			connections = connections.filter((item)=>{return item.id !== output_conn.id})
    			this.$store.dispatch('calculations/setConnections',connections)
    		}
    		
    	}
    	else if(this.node.type=="equation")
    	{
    		let input_conns = connections.filter((item)=>{return item.to==this.node.id})
    		for(let input_conn of input_conns)
    		{
    			connections = connections.filter((item)=>{return item.id !== input_conn.id})
    			this.$store.dispatch('calculations/setConnections',connections)
    		}
    		
    	}
    	else
    	{
    		let output_conns = connections.filter((item)=>{return item.from==this.node.id})
    		for(let output_conn of output_conns)
    		{
    			connections = connections.filter((item)=>{return item.id !== output_conn.id})
    		}
    		

    		let input_conns = connections.filter((item)=>{return item.to==this.node.id})

    		for(let input_conn of input_conns)
    		{
    			connections = connections.filter((item)=>{return item.id !== input_conn.id})
    		}
    		this.$store.dispatch('calculations/setConnections',connections)
    		
    	}

    	setTimeout(()=>{
    		nodes = nodes.filter((item)=>{return item.id !== nodes[node_ind].id})
    		this.$store.dispatch('calculations/setNodes',nodes)
    		this.$store.state.calculations.fromnode = null
    	},10)

    	
    },

  	
  }

}
</script>

<style lang="css" scoped>
	.select_area{
		justify-content: space-between;
	}
</style>